export class ArrayUtils {

	static isEmpty(array) {
		return array == null || array.length === 0;
	}

}
